import * as Yup from 'yup'


Yup.addMethod(Yup.string, "valida_patente", function (errorMessage) {
    return this.test(`valida_patente`, errorMessage, function (patente) {
        if (patente && patente.length > 0) {
            var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i;
            if (regex.test(patente)) {
                return true;
            } else {
                return false;
            }
        }
     
        return true;
  })
})
export const validationSchemas = (isFechas, isDias, selected, respuestacia, motivorpta) => {
  
  let validationObject = { };
  
  if(isDias){
    validationObject["dias"] = Yup.string().required('Obligatorio');
   
  }
  if(isFechas){
    validationObject["tipofecha"] = Yup.string().required('Este campo es obligatorio');
  }
  if (respuestacia && motivorpta == "") {
    validationObject["motivorpta"] = Yup.string().required('Seleccione Motivo Respuesta');
  }

if(selected==='patente'){
      

    validationObject["patente"] = Yup.string().test(
      "len",
      "La Patente no es válida",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return val.length === 0 || (val.length >= 2 && val.length <= 7);
      }
    ).valida_patente("La Patente no es válida").required('Este campo es obligatorio');
  }else{
    validationObject[selected] = Yup.string().required('Este campo es obligatorio');
  }
  return Yup.object().shape(validationObject);
}

